import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/landing-page/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./pages/contact-us/contact.module').then(m => m.ContactUsModule)
  },
  {
    path:'pricing-plan/:type',
    loadChildren: () =>
      import('./pages/pricing-plan/pricing.module').then(m => m.PricingModule)
  },
  {
    path:'downloads/:type',
    loadChildren: () =>
      import('./pages/download/download.module').then(m => m.DownloadModule)
  },
  {
    path:'database-hosting',
    loadChildren: () =>
      import('./pages/database-hosting/database-hosting.module').then(m => m.DatabaseHostingModule)
  },
  {
    path:'app-hosting',
    loadChildren: () =>
      import('./pages/database-hosting/database-hosting.module').then(m => m.DatabaseHostingModule)
  },
  {
    path:'website-hosting',
    loadChildren: () =>
      import('./pages/database-hosting/database-hosting.module').then(m => m.DatabaseHostingModule)
  },
  {
    path:'database-migration',
    loadChildren: () =>
      import('./pages/database-migration/database-migration.module').then(m => m.DatabaseMigrationModule)
  },
  {
    path:'cloud-it-department',
    loadChildren: () =>
      import('./pages/database-migration/database-migration.module').then(m => m.DatabaseMigrationModule)
  },
  {
    path:'database-application-migration',
    loadChildren: () =>
      import('./pages/database-migration/database-migration.module').then(m => m.DatabaseMigrationModule)
  },
  {
    path:'hosting/:type',
    loadChildren: () =>
      import('./pages/webpage-hosting/webpage-hosting-module').then(m => m.WebpageHostingModule)
  },
  {
    path:'cluster-hosting',
    loadChildren: () =>
      import('./pages/cluster-hosting/cluster-hosting.module').then(m => m.ClusterHostingModule)
  },
  {
    path:'login',
    loadChildren: () =>
      import('./components/login/login.module').then(m => m.LoginModule)
  },
  {
    path:'registration',
    loadChildren: () =>
      import('./components/registration/registation.module').then(m=>m.RegistrationModule)
  },
  {
    path:'product',
    loadChildren: () =>
      import('./pages/product-page/product.module').then(m=>m.ProductModule)
  },
  {
    path: 'policy',
    loadChildren: () =>
      import('./pages/policy/policy.module').then(m => m.PolicyModule)
  },
  {
    path: 'terms',
    loadChildren: () =>
      import('./pages/terms/terms.module').then(m => m.TermsModule)
  },
  {
    path: 'payment-success',
    loadChildren: () =>
      import('./pages/payment-success/payment-success.module').then(m => m.PaymentSuccessModule)
  },
  {
    path: 'payment-cancel',
    loadChildren: () =>
      import('./pages/payment-cancel/payment-cancel.module').then(m => m.PaymentCancelModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
